import { render, staticRenderFns } from "./PayrollEmployeeHistory.vue?vue&type=template&id=2caac288&scoped=true&"
import script from "./PayrollEmployeeHistory.vue?vue&type=script&lang=js&"
export * from "./PayrollEmployeeHistory.vue?vue&type=script&lang=js&"
import style0 from "./PayrollEmployeeHistory.vue?vue&type=style&index=0&id=2caac288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caac288",
  null
  
)

export default component.exports